import { useEffect, useState } from 'react';
import axios from 'axios';

// Module-scoped cache so the two consumers (Home + Hero) share one fetch.
let cachedPromise = null;

function fetchOnce() {
  if (cachedPromise) return cachedPromise;
  cachedPromise = axios
    .get(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`)
    .then((r) => r.data)
    .catch(() => ({ source: 'fallback', reviews: [], rating: null, userRatingCount: null }));
  return cachedPromise;
}

/**
 * Fetch the site's live Google reviews payload (or the fallback shape
 * when the backend has no keys). Both the ReviewsMarquee section and
 * the hero rating badge subscribe via this hook; the module-level cache
 * guarantees only one network round-trip per page load.
 */
export default function useGoogleReviews() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let mounted = true;
    fetchOnce().then((d) => {
      if (mounted) setData(d);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return data;
}
